import React from 'react';
import { useNavigate } from 'react-router-dom';
import StarRating from './StarRating';
import useAuthStore from '../stores/useAuthStore';

const CourseCard = ({ course, isEnrolled, enrollmentSource = 'personal', sourceName = null }) => {
  const navigate = useNavigate();
  const user = useAuthStore(state => state.user);


  const handleCardClick = () => {
    if (isEnrolled) {
      if (user?.role === "student") {
        handleLearningClick();
      } else if (user.role === "student") {
        handleMyCourseClick();
      }

    } else {
      handleNonEnrolledClick();
    }
  };

  const handleNonEnrolledClick = () => {
    navigate(`/course/${course?.slug}/${course?._id}`);
  };

  const handleEnrollClick = (e) => {
    navigate(`/course/${course?.slug}/${course?._id}`);
  };

  const handleLearningClick = () => {
    navigate(`/student/learning/${course?._id}`);
  };

  const handleMyCourseClick = () => {
    navigate(`/instructor/my-courses`);
  };

  return (
    <div
      className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 overflow-hidden hover:shadow-md transition cursor-pointer"
      onClick={handleCardClick}
    >
      <div className="relative">
        <img
          src={`${process.env.REACT_APP_SOCKET_URL}${course?.thumbnail}`}
          alt={course?.title}
          className="w-full h-48 object-cover"
        />

        {course?.price > 0 ? (
          <div className="absolute top-4 right-4 bg-primary-500 text-white px-2 py-1 rounded text-sm font-medium">
            ₦{course.price.toLocaleString('en-NG')}
          </div>
        ) : (
          <div className="absolute top-4 right-4 bg-success-500 text-white px-2 py-1 rounded text-sm font-medium">
            Free
          </div>
        )}
      </div>

      <div className="p-4">

        {course?.isInPartnerProgram && course?.instructor?.isPartner && course?.instructor?.partnerDetails?.institutionLogo && (
          <div className='flex flex-wrap gap-2 items-center mb-2'>
            <div className='rounded border border-gray-300 dark:border-neutral-300'>
              <img
                src={`${process.env.REACT_APP_SOCKET_URL}/public${course?.instructor?.partnerDetails?.institutionLogo}`}
                alt="Partner"
                className="w-8 h-8 object-contain"
              />
            </div>
            <div className='flex flex-col leading-none'>
               <h2 className='text-sm font-medium dark:text-neutral-100'>{course?.instructor?.partnerDetails?.institutionName}</h2>
               <span className='text-xs font-light text-primary-700 dark:text-primary-300'>BoleumLearn Partner</span>
            </div>
          </div>
        )}

        <h3 className="font-semibold text-neutral-900 dark:text-white mb-2 line-clamp-2">
          {course?.title}
        </h3>

        {enrollmentSource !== 'personal' && sourceName && (
          <span className="inline-block px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 mb-2">
            Via {enrollmentSource === 'org' ? 'Organization' : 'School'}: {sourceName}
          </span>
        )}

        <div className="flex items-center mb-3">
          <div>
            <p className="text-sm font-medium text-neutral-900 dark:text-neutral-300">
              {course?.instructor?.name}
            </p>
            <p className="text-xs text-neutral-600 dark:text-neutral-400">
              Course Instructor
            </p>
          </div>
        </div>

        {!isEnrolled && (
          <div className="flex items-center mb-4">
            <span
              className="px-2 mr py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-300 cursor-pointer hover:bg-primary-200 dark:hover:bg-primary-900/50"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/categories/${course?.category?.slug}`);
              }}
            >
              {course?.category?.name}
            </span>
            <span className="text-sm ml-2 text-neutral-600 dark:text-neutral-400">
              {course?.level}
            </span>
          </div>
        )}

        {!isEnrolled && (
          <div className="flex items-center mb-4">
            <span className="text-sm text-neutral-600 dark:text-neutral-400 mr-4 flex">
              <StarRating rating={course?.rating || 0} />  <span className='ml-2'>({course?.reviews?.length || 0} reviews)</span>
            </span>
            <span className="text-sm text-neutral-600 dark:text-neutral-400">
              {course?.totalEnrollments || 0} students
            </span>
          </div>
        )}

        {!isEnrolled && (
          <button
            onClick={handleEnrollClick}
            className="w-full py-2 px-4 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-800 transition-all duration-200"
          >
            Enroll Now
          </button>
        )}

        {user?.role === "student" && (
          <>
            {(isEnrolled) && (
              <button
                onClick={handleLearningClick}
                className="w-full mt-4 py-2 px-4 bg-success-500 hover:bg-success-600 text-white text-sm font-medium rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-success-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-800 transition-all duration-200"
              >
                Continue Learning
              </button>
            )}
          </>
        )}

        {user?.role === "instructor" && (
          <>
            {(isEnrolled) && (
              <button
                onClick={handleMyCourseClick}
                className="w-full mt-4 py-2 px-4 bg-success-500 hover:bg-success-600 text-white text-sm font-medium rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-success-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-800 transition-all duration-200"
              >
                This is your course
              </button>
            )}
          </>
        )}


      </div>
    </div>
  );
};

export default CourseCard;